export default "__VITE_ASSET__BtjVkhJR__"